import styled from '@emotion/styled';

const ErrorIconContainer = styled('div')`
  margin-left: 10px;
`;

export default ErrorIconContainer;
